import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { UserProfile } from '~/core/dapi/models';

export function isAddressPopulatedForUserProfile(userProfile: any) {
  const ADDRESS_FIELDS = ['addressStreet', 'addressCity', 'addressState', 'addressZip'];
  return ADDRESS_FIELDS.every((field) => !isEmpty(userProfile[field]));
}

/**
 * Determine if a given user profile represents a minor (user < 18 years old).
 *
 * If there is no birth date set, or the birth date is invalid, returns false.
 * @param profile The user profile object to check.
 * @returns True if the user is a minor, false otherwise.
 */
export function isUserProfileAMinor(profile?: UserProfile) {
  if (!profile?.birth_date) {
    return false;
  }

  const birthDate = moment(profile.birth_date);

  if (!birthDate.isValid()) {
    return false;
  }

  return moment().diff(birthDate, 'years') < 18;
}
